import type { FlagConfiguration } from '@atlassian/jira-flags/src/services/types';
import messages from './messages.tsx';

export const PACKAGE_LOCATION = 'jira-business.categories.src.services.delete-category';

export const DELETE_FAILED_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.deleteErrorTitle,
	description: messages.deleteErrorMessage,
};

export const DELETE_SUCCESS_FLAG: FlagConfiguration = {
	type: 'success',
	title: messages.deleteSuccessTitle,
	description: messages.deleteSuccessMessage,
};

export const QUERY_NAME = 'deleteJwmCategory';
